import { tableDefaults } from "./defaultConfig.js";

export const teamTableConfig = () => ({
    ...tableDefaults,
    index: "id",
    columns: [
        {
            title: "Team",
            field: "name",
            widthGrow: 1,
            headerFilter: "input",
            headerFilterFunc: (headerValue, rowValue, rowData) =>
                String(rowData.name ?? "").toLowerCase().includes(headerValue.toLowerCase()),
        },
        { title: "Berechtigungen", field: "permissionId", widthGrow: 3, headerFilter: "list" },
        { title: "Aktivitäten", field: "activityId", widthGrow: 3, headerFilter: "list" }
    ],
});